import { ReactNode } from "react";

import { useCategoryContext } from "@/components/General/FlyoutMenu/context/category.context";
import { Mapped } from "@/context/mapped.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Links = ({ className, children }: Props) => {
    const { category } = useCategoryContext();

    return (
        <ul className={className}>
            <Mapped array={category?.subCategories ?? []}>{children}</Mapped>
        </ul>
    );
};
